import React from 'react';
import { Clock, Mail, MapPin, Phone, UserRound } from 'lucide-react';
import { getOriginMeta, getReservationContactPhone, getReservationGuestName, getReservationTimeValue, getStatusMeta } from './utils';

export default function ReservationDetailsRow({ reservation }) {
  const status = getStatusMeta(reservation?.status);
  const origin = getOriginMeta(reservation?.origin);
  const phone = getReservationContactPhone(reservation);

  return (
    <div className="grid gap-4 px-6 py-4 md:grid-cols-2 xl:grid-cols-4">
      <div className="space-y-2 rounded-xl border bg-white p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Gast</p>
        <p className="font-semibold text-slate-900">{getReservationGuestName(reservation)}</p>
        <div className="space-y-1 text-sm text-slate-500">
          {phone ? (
            <p className="flex items-center gap-2">
              <Phone className="h-3.5 w-3.5" />
              <span>{phone}</span>
            </p>
          ) : null}
          {reservation?.email ? (
            <p className="flex items-center gap-2">
              <Mail className="h-3.5 w-3.5" />
              <span>{reservation.email}</span>
            </p>
          ) : null}
        </div>
      </div>

      <div className="space-y-2 rounded-xl border bg-white p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Reservierung</p>
        <div className="space-y-1 text-sm text-slate-600">
          <p className="flex items-center gap-2">
            <Clock className="h-3.5 w-3.5" />
            <span>{getReservationTimeValue(reservation)} Uhr</span>
          </p>
          <p className="flex items-center gap-2">
            <UserRound className="h-3.5 w-3.5" />
            <span>{reservation?.party_size || 0} Personen</span>
          </p>
          <p className="flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5" />
            <span>{reservation?.table_name || reservation?.table?.name || 'Nicht zugewiesen'}</span>
          </p>
        </div>
      </div>

      <div className="space-y-2 rounded-xl border bg-white p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Status</p>
        <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${status.pillClass}`}>
          {status.label}
        </span>
        <span className={`ml-2 inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${origin.className}`}>
          {origin.label}
        </span>
      </div>

      <div className="space-y-2 rounded-xl border bg-white p-4">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Notizen</p>
        <p className="text-sm text-slate-600">
          {reservation?.notes || reservation?.special_requests || 'Keine Notizen vorhanden.'}
        </p>
      </div>
    </div>
  );
}
